import React from 'react'
import strings from '../lang/strings'
import Login from '../pages/auth/login'
import Signup from '../pages/auth/signup'
import Find from '../pages/auth/find'
import Dashboard from '../pages/dashboard/dashboard'
import WineeDataList from '../pages/winee/data_list'
// import Chat from '../pages/chat/chat'
import AnalystList from '../pages/analyst/analyst_list'
import AnalystDetail from '../pages/analyst/analyst_detail'
import AnalystGameDetail from '../pages/analyst/game_detail'
import AnalystBettingDetail from '../pages/analyst/betting_detail'
import AnalystVictoryDetail from '../pages/analyst/victory_detail'
import AnalystDailyDetail from '../pages/analyst/daily_detail'
import BjList from '../pages/bj/bj_list'
import BjDetail from '../pages/bj/bj_detail'
import BjResult from '../pages/bj/bj_result'
import DataList from '../pages/my_data/data_list'
import ProductInfo from '../pages/my_data/product_info'
import ProductNew from '../pages/my_data/product_new'
import SaleList from '../pages/my_data/sale_list'
import BJNew from '../pages/my_data/bj_new'
import AnalystNewBetting from '../pages/my_data/analyst_new_betting'
import AnalystNewGame from '../pages/my_data/analyst_new_game'
import AnalystNewVictory from '../pages/my_data/analyst_new_victory'
import AnalystNewDaily from '../pages/my_data/analyst_new_daily'
import Member from '../pages/mypage/member'
import Coupon from '../pages/mypage/coupon'
import PointList from '../pages/mypage/point_list'
import NobankList from '../pages/mypage/nobank_list'
import PayList from '../pages/mypage/pay_list'
import TicketList from '../pages/mypage/ticket_list'
import MoMyPage from '../pages/mypage/mo_mypage'
import AlarmList from '../pages/mypage/alarm_list'
import AlarmDetail from '../pages/mypage/alarm_detail'
import Term from '../pages/cs/term'
import OneToOne from '../pages/cs/one_to_one'
import Event from '../pages/event/event'
import Notice from '../pages/cs/notice'
import Faq from '../pages/cs/faq'
import Item from '../pages/item/item'
import NoticeDetail from '../pages/cs/notice_detail'
import PayDo from '../pages/mypage/pay_do'
import Cs from '../pages/cs/cs'

export const Extra = [
  {
    path: '/login', title: strings.login, exact: true, private: false,
    component: () => <Login />
  },
  {
    path: '/signup', title: strings.signup, exact: true, private: false,
    component: () => <Signup />
  },
  {
    path: '/find/:type', title: strings.find_id_pwd, exact: true, private: false,
    component: () => <Find />
  },
  {
    path: '/find/0', title: strings.find_id, exact: true, private: false,
    component: () => <Find />
  },
  {
    path: '/find/1', title: strings.find_pwd, exact: true, private: false,
    component: () => <Find />
  },
  {
    path: '/dashboard', title: strings.site_title, exact: true, private: false,
    component: () => <Dashboard />
  },
  // {
  //   path: '/chat/p', title: strings.chat, exact: true, private: false,
  //   component: () => <Chat />
  // },
  // {
  //   path: '/chat/:type', title: strings.chat, exact: true, private: false,
  //   component: () => <Chat />
  // },
  {
    path: '/mypage/mo_mypage', title: strings.info_modify, exact: true, private: true,
    component: () => <MoMyPage />
  },
  {
    path: '/mypage/pay_do', title: '', exact: true, private: true,
    component: () => <PayDo />
  },
  {
    path: '/mypage', title: strings.info_modify, exact: true, private: true,
    component: () => <Member />
  },
  {
    path: '/product_new/:product_id?', title: strings.product_new, exact: true, private: true,
    component: () => <ProductNew />
  },
  {
    path: '/product_info', title: strings.my_product_info, exact: true, private: true,
    component: () => <ProductInfo />
  },
  {
    path: '/nobank_list', title: strings.nobank_list, exact: true, private: true,
    component: () => <NobankList />
  },
  {
    path: '/point_list', title: strings.point_list, exact: true, private: true,
    component: () => <PointList />
  },
  {
    path: '/coupon_list', title: strings.coupon_list, exact: true, private: true,
    component: () => <Coupon />
  },
  {
    path: '/pay_list', title: strings.pay_list, exact: true, private: true,
    component: () => <PayList />
  },
  {
    path: '/ticket_list', title: strings.ticket_list, exact: true, private: true,
    component: () => <TicketList />
  },
  {
    path: '/alarm_list', title: strings.data_list, exact: true, private: true,
    component: () => <AlarmList />
  },
  {
    path: '/bj/list', title: strings.bj_data, index: 1, exact: true, private: false,
    component: () => <BjList />
  },
  {
    path: '/bj/list/:type', title: strings.bj_data, index: 1, exact: true, private: false,
    component: () => <BjList />
  },
  {
    path: '/bj/bj_result', title: strings.bj_detail, index: 1, exact: true, private: true,
    component: () => <BjResult />
  },
  {
    path: '/bj/detail/:bj_id', index: 1, exact: true, private: false,
    component: () => <BjDetail />
  },
  {
    path: '/analyst/betting_detail', title: strings.bj_detail, index: 2, exact: true, private: true,
    component: () => <AnalystBettingDetail />
  },
  {
    path: '/analyst/game_detail', title: strings.bj_detail, index: 2, exact: true, private: true,
    component: () => <AnalystGameDetail />
  },
  {
    path: '/analyst/victory_detail', title: strings.bj_detail, index: 2, exact: true, private: true,
    component: () => <AnalystVictoryDetail />
  },
  {
    path: '/analyst/daily_detail', title: strings.bj_detail, index: 2, exact: true, private: true,
    component: () => <AnalystDailyDetail />
  },
  // {
  //   path: '/analyst/detail', title: strings.analyst_member, index: 2, exact: true, private: false,
  //   component: () => <AnalystDetail />
  // },
  // {
  //   path: '/analyst/list', title: strings.analyst_member, index: 2, exact: true, private: false,
  //   component: () => <AnalystList />
  // },
  // {
  //   path: '/analyst/list/:type', title: strings.analyst_member, index: 2, exact: true, private: false,
  //   component: () => <AnalystList />
  // },
  {
    path: '/my_data', title: strings.data_list, index: 3, exact: true, private: true,
    component: () => <DataList />
  },
  {
    path: '/my_data/analyst_new_game', title: strings.bj_new, index: 3, exact: true, private: true,
    component: () => <AnalystNewGame />
  },
  {
    path: '/my_data/analyst_new_betting', title: strings.bj_new, index: 3, exact: true, private: true,
    component: () => <AnalystNewBetting />
  },
  {
    path: '/my_data/analyst_new_victory', title: strings.bj_new, index: 3, exact: true, private: true,
    component: () => <AnalystNewVictory />
  },
  {
    path: '/my_data/analyst_new_daily', title: strings.bj_new, index: 3, exact: true, private: true,
    component: () => <AnalystNewDaily />
  },
  {
    path: '/my_data/bj_new', title: strings.bj_new, index: 3, exact: true, private: true,
    component: () => <BJNew />
  },
  {
    path: '/my_data/bj_new/:type', title: strings.bj_new, index: 3, exact: true, private: true,
    component: () => <BJNew />
  },
  {
    path: '/my_data/bj_new/0', title: strings.bj_new, index: 3, exact: true, private: true,
    component: () => <BJNew />
  },
  {
    path: '/my_data/bj_new/1', title: strings.bj_new, index: 3, exact: true, private: true,
    component: () => <BJNew />
  },
  // {
  //   path: '/event', title: strings.event, index: 5, exact: true, private: false,
  //   component: () => <Event />
  // },
  // {
  //   path: '/event_detail', title: strings.event, index: 5, exact: true, private: false,
  //   component: () => <NoticeDetail />
  // },
  {
    path: '/cs', title: strings.notice, index: 5, exact: true, private: false,
    component: () => <Cs/>
  },
  {
    path: '/cs/notice_detail/:id', title: strings.notice, index: 5, exact: true, private: false,
    component: () => <NoticeDetail />
  },
  {
    path: '/cs', title: strings.po_terms, index: 5, exact: true, private: false,
    component: () => <Cs tabIndex={2}/>
  },
  
]

export const MenuMyData = [
  {
    path: '/my_data/data_list', title: strings.data_list, index: 3, exact: true, private: true,
    component: () => <DataList />
  },
  {
    path: '/my_data/sale_list', title: strings.sale_list, index: 3, exact: true, private: true,
    component: () => <SaleList />
  },
]

export const MenuCs = [
  {
    path: '/cs/openchat', title: strings.kakaoCs, index: 5, exact: true, private: false, url : strings.kakaoOpenLink
  },
  {
    path: '/cs/notice', title: strings.notice, index: 5, exact: true, private: false,
    component: () => <Notice />
  },
  {
    path: '/cs/faq', title: strings.faq, index: 5, exact: true, private: false,
    component: () => <Faq />
  },
  {
    path: '/cs/term/terms', title: strings.po_terms, index: 5, exact: true, private: false,
    component: () => <Term type={0}/>
  },
  {
    path: '/cs/term/privacy', title: strings.po_privacy, index: 5, exact: true, private: false,
    component: () => <Term type={1}/>
  },
  {
    path: '/cs/one_to_one', title: strings.cs, index: 5, exact: true, private: true,
    component: () => <OneToOne />
  },
]

export const MenuMy = [
  { title: strings.info_modify, path: '/mypage' },
  { title: strings.my_product_info, path: '/product_info', bjcheck : true },
  { title: strings.nobank_list, path: '/nobank_list' },
  { title: strings.point_history, path: '/point_list' },
  { title: strings.coupon_list, path: '/coupon_list' },
  { title: strings.pay_list, path: '/pay_list' },
  { title: strings.ticket_list, path: '/ticket_list' },
  { title: strings.alarm_list, path: '/alarm_list' },
  { title: strings.logout, logout: true },
  { title: strings.signout, signout: true },
]

const Menu = [
  {
    path: '/winee',
    title: strings.wn_data,
    index: -1,
    exact: true,
    private: false,
    component: () => <WineeDataList />
  },
  // {
  //   path: '/chat',
  //   title: strings.chat,
  //   index: 0,
  //   exact: true,
  //   private: false,
  //   mo: true,
  //   component: () => <Chat />
  // },
  {
    path: '/bj/list',
    title: strings.bj_tab_name,
    index: 1,
    exact: true,
    private: false,
    component: () => <BjList />
    // children: [
    //   {
    //     path: '/bj/list/0', title: strings.wn_bj, index: 1, exact: true, private: false,
    //     component: () => <BjList />
    //   },
    //   {
    //     path: '/bj/list/1', title: strings.best_bj, index: 1, exact: true, private: false,
    //     component: () => <BjList />
    //   },
    //   {
    //     path: '/bj/list/2', title: strings.partner_bj, index: 1, exact: true, private: false,
    //     component: () => <BjList />
    //   }
    // ]
  },
  // {
  //   path: '/analyst/list',
  //   title: strings.analyst_member,
  //   index: 2,
  //   children: [
  //     {
  //       path: '/analyst/list/0', title: strings.analyst_winee, index: 2, exact: true, private: false,
  //       component: () => <AnalystList />
  //     },
  //     {
  //       path: '/analyst/list/1', title: strings.analyst_intern, index: 2, exact: true, private: false,
  //       component: () => <AnalystList />
  //     },
  //   ]
  // },
  {
    path: '/my_data',
    title: strings.my_analyst,
    index: 3,
    children: MenuMyData
  },
  {
    path: '/item',
    title: strings.item_purchase,
    index: 4,
    exact: true,
    private: false,
    component: () => <Item />
  },
  {
    path: '/cs',
    title: strings.cs_center,
    index: 5,
    children: MenuCs
  },
]

export default Menu
